{
  "Samsung": {
    "Galaxy S26 Ultra": [
      "SM-S948"
    ],
    "Galaxy S26+": [
      "SM-S947"
    ],
    "Galaxy S26": [
      "SM-S942"
    ],
    "Galaxy S25 FE": [
      "SM-S731"
    ],
    "Galaxy S25 Edge": [
      "SM-S937"
    ],
    "Galaxy S25 Ultra": [
      "SM-S938"
    ],
    "Galaxy S25+": [
      "SM-S936"
    ],
    "Galaxy S25": [
      "SM-S931"
    ],
    "Galaxy S24 FE": [
      " SM-S721"
    ],
    "Galaxy S24 Ultra": [
      "SM-S928"
    ],
    "Galaxy S24+": [
      "SM-S926"
    ],
    "Galaxy S24": [
      "SM-S921"
    ],
    "Galaxy S23 FE": [
      "SM-S711"
    ],
    "Galaxy S23 Ultra": [
      "SM-S918",
      "SCG20",
      "SC-52D"
    ],
    "Galaxy S22 Ultra": [
      "SM-S908",
      "SCG14",
      "SC-52C"
    ],
    "Galaxy S23+": [
      "SM-S916"
    ],
    "Galaxy S22+": [
      "SM-S906"
    ],
    "Galaxy S23": [
      "SCG19",
      "SC-51D",
      "SM-S911C"
    ],
    "Galaxy S22": [
      "SM-S901",
      "SC-51C",
      "SCG13"
    ],
    "Galaxy S21 Ultra 5G": [
      "SM-G998",
      "SCG10",
      "SC-52B"
    ],
    "Galaxy S21+ 5G": [
      "SM-G996",
      "SCG10"
    ],
    "Galaxy S21 5G": [
      "SM-G991",
      "SC-51B",
      "SCG09"
    ],
    "Galaxy S21 FE 5G": [
      "SM-G990"
    ],
    "Galaxy S20 FE 5G": [
      "SM-G781"
    ],
    "Galaxy S20 Ultra 5G": [
      "SM-G988",
      "SCG03"
    ],
    "Galaxy S20+": [
      "SM-G985"
    ],
    "Galaxy S20 5G": [
      "SM-G981",
      "SCG01",
      "SC-51A"
    ],
    "Galaxy S20": [
      "SM-G980"
    ],
    "Galaxy S10 Lite": [
      "SM-G770"
    ],
    "Galaxy S10 5G": [
      "SM-G977"
    ],
    "Galaxy S10+": [
      "SM-G975",
      "SC-05L"
    ],
    "Galaxy S10": [
      "SM-G973",
      "SCV41"
    ],
    "Galaxy S10e": [
      "SM-G970"
    ],
    "Galaxy Note 20 Ultra": [
      "SM-N985"
    ],
    "Galaxy Note 20 5G": [
      "SM-N981"
    ],
    "Galaxy Note 20": [
      "SM-N980"
    ],
    "Galaxy Note 10+": [
      "SM-N976",
      "SM-N976Q"
    ],
    "Galaxy Note 10": [
      " SM-N970"
    ],
    "Galaxy Note 10 Lite": [
      "SM-N770"
    ],
    "Galaxy Note 9": [
      "SM-N960",
      "SCV40"
    ],
    "Galaxy A72": [
      "SM-A725"
    ],
    "Galaxy A71 5G": [
      "SM-A716"
    ],
    "Galaxy A71": [
      "SM-A715"
    ],
    "Galaxy A70": [
      "SM-A705"
    ],
    "Galaxy A56 5G": [
      "SM-A566"
    ],
    "Galaxy A55 5G": [
      "SM-A556"
    ],
    "Galaxy A54 5G": [
      "SM-A546",
      "SCG21",
      "SC-53D",
      "SM-A546S"
    ],
    "Galaxy A53": [
      "SM-A536",
      "SCG15",
      "SC-53C"
    ],
    "Galaxy A52 5G": [
      "SM-A526",
      "SM-A528",
      "SC-53B"
    ],
    "Galaxy A52s 5G": [
      "SM-A528"
    ],
    "Galaxy A52": [
      "SM-A525"
    ],
    "Galaxy A51": [
      "SM-A515",
      "SCG07",
      "SC-54A",
      "SM-A516"
    ],
    "Galaxy A50": [
      "SM-A505",
      "SM-S506DL"
    ],
    "Galaxy A36 5G": [
      "SM-A366"
    ],
    "Galaxy A35 5G": [
      "SM-A356"
    ],
    "Galaxy A26 5G": [
      "SM-A266"
    ],
    "Galaxy A25 5G": [
      "SM-A256"
    ],
    "Galaxy A17 5G": [
      "SM-A176"
    ],
    "Galaxy A16 5G": [
      "SM-A165"
    ],
    "Samsung Galaxy Z Flip 7 FE": [
      "SM-F761"
    ],
    "Samsung Galaxy Z Flip 7": [
      "SM-F766"
    ],
    "Samsung Galaxy Z Flip 6": [
      "SM-F741"
    ],
    "Samsung Galaxy Z Flip 5": [
      "SM-F731"
    ],
    "Samsung Galaxy Z Flip 4": [
      "SM-F721",
      "SCG17",
      "SC-54C",
      "SM-F721C"
    ],
    "Samsung Galaxy Z Flip 5G": [
      "SM-F707",
      "SCV47",
      "SCG0"
    ],
    "Samsung Galaxy Z Flip": [
      "SM-F700",
      "SM-F707",
      "SCV47",
      "SCG04"
    ],
    "Samsung Galaxy Z Fold 7": [
      "SM-F966"
    ],
    "Samsung Galaxy Z Fold 6": [
      "SM-F956"
    ],
    "Samsung Galaxy Z Fold 5": [
      "SM-F946"
    ],
    "Samsung Galaxy Z Fold 4": [
      "SM-F936",
      "SCG16",
      "SC-55C"
    ],
    "Samsung Galaxy Z Fold 3 5G": [
      "SM-F926",
      "SCG11",
      "SC-55B"
    ],
    "Samsung Galazy Z Fold 3": [
      "SM-F926"
    ],
    "Samsung Galaxy Z Fold 2 5G": [
      "SM-F916",
      "SCG05"
    ],
    "Samsung Galaxy Z Fold 2": [
      "SM-F916",
      "SCG05"
    ]
  },
  "Pixel": {
    "Pixel 10a": [
      "Pixel 10a",
      "GE1GQ",
      "GV0BP",
      "G4H7L"
    ],
    "Pixel 10 Pro Fold": [
      "Pixel 10 Pro Fold",
      "GU0NP",
      "GM66V"
    ],
    "Pixel 10 Pro XL": [
      "Pixel 10 Pro XL",
      "G45RY",
      "GUL82",
      "GYPW4"
    ],
    "Pixel 10 Pro": [
      "Pixel 10 Pro",
      "GEHN3",
      "G4QUR",
      "GN4F5"
    ],
    "Pixel 10": [
      "Pixel 10",
      "GK2MP",
      "GLBW0",
      "GL066"
    ],
    "Pixel 9a": [
      "Pixel 9a",
      "GXQ96",
      "GTF7P",
      "G3Y12"
    ],
    "Pixel 9 Pro Fold": [
      "Pixel 9 Pro Fold",
      "GGH2X",
      "GC15S"
    ],
    "Pixel 9 Pro XL": [
      "Pixel 9 Pro XL",
      "GGX8B",
      "GZC4K",
      "GQ57S"
    ],
    "Pixel 9 Pro": [
      "Pixel 9 Pro",
      "GR83Y",
      "GEC77",
      "GWVK6"
    ],
    "Pixel 9": [
      "Pixel 9",
      "G2YBB",
      "GUR25",
      "G1B60"
    ],
    "Pixel Fold": [
      "Pixel Fold",
      "G9FPL"
    ],
    "Pixel 8a": [
      "Pixel 8a",
      "GKV4X",
      "G6GPR",
      "G8HHN",
      "G576D"
    ],
    "Pixel 8 Pro": [
      "Pixel 8 Pro",
      "GC3VE",
      "G1MNW"
    ],
    "Pixel 8": [
      "Pixel 8",
      "GKWS6",
      "G9BQD",
      "GA04851-US",
      "GZPFO",
      "GPJ41"
    ],
    "Pixel 7a": [
      "Pixel 7a",
      "GWKK3",
      "GHL1X",
      "G0DZQ",
      "G82U8"
    ],
    "Pixel 7 pro": [
      "Pixel 7 Pro",
      "GP4BC",
      "GE2AE",
      "GFE4J"
    ],
    "Pixel 7": [
      "Pixel 7",
      "GVU6C",
      "GQML3",
      "GO3Z5"
    ],
    "Pixel 6 pro": [
      "Pixel 6 Pro",
      "GLUOG",
      "G8VOU",
      "GF5KQ"
    ],
    "Pixel 6a": [
      "Pixel 6a",
      "GX7AS",
      "GB62Z",
      "G1AZG",
      "GB17L"
    ],
    "Pixel 6": [
      "Pixel 6",
      "GB7N6",
      "G9S9B16",
      "G9S9B",
      "GR1YH"
    ],
    "Pixel 5a 5G": [
      "Pixel 5a (5G)",
      "G1F8F",
      "G4S1M"
    ],
    "Pixel 5": [
      "Pixel 5",
      "GD1YQ",
      "GTT9Q",
      "G5NZ6"
    ],
    "Pixel 4a 5G": [
      "Pixel 4a (5G)"
    ],
    "Pixel 4 XL": [
      "Pixel 4 XL"
    ],
    "Pixel 4a": [
      "Pixel 4a"
    ],
    "Pixel 4": [
      "Pixel 4"
    ],
    "Pixel 3 XL": [
      "Pixel 3 XL"
    ],
    "Pixel 3a XL": [
      "Pixel 3a XL"
    ],
    "Pixel 3a": [
      "Pixel 3a"
    ],
    "Pixel 3": [
      "Pixel 3"
    ]
  },
  "OnePlus": {
    "OnePlus Open": [
      "OnePlus Open",
      "CPH2551"
    ],
    "OnePlus 13": [
      "OnePlus 13",
      "CPH2655",
      "CPH2653",
      "PJZ110",
      "CPH2649"
    ],
    "OnePlus 13R": [
      "OnePlus 13R",
      "CPH2645",
      "CPH2691",
      "CPH2647"
    ],
    "OnePlus 12": [
      "OnePlus 12",
      "PJD110",
      "CPH2573",
      "CPH2581",
      "CPH2583"
    ],
    "OnePlus 12R": [
      "OnePlus 12R",
      "CPH2609",
      "CPH2585",
      "CPH2611"
    ],
    "OnePlus 7T": [
      "HD190",
      "OnePlus 7T"
    ],
    "OnePlus 7 Pro": [
      "GM191",
      "OnePlus 7 Pro"
    ],
    "OnePlus 7T Pro": [
      "HD191",
      "OnePlus 7T Pro"
    ],
    "OnePlus 7": [
      "GM190",
      "OnePlus 7"
    ],
    "OnePlus 8T": [
      "KB200",
      "OnePlus 8T"
    ],
    "OnePlus 8 Pro": [
      "IN202",
      "OnePlus 8 Pro"
    ],
    "OnePlus 8": [
      "IN201",
      "OnePlus 8"
    ],
    "OnePlus 9 Pro": [
      "LE212",
      "OnePlus 9 Pro"
    ],
    "OnePlus 9R": [
      "OnePlus 9R",
      "LE210"
    ],
    "OnePlus 9": [
      "LE211",
      "OnePlus 9"
    ],
    "OnePlus 10 Pro": [
      "NE221",
      "OnePlus 10 Pro",
      "OnePlus 10 Pro 5G"
    ],
    "OnePlus 10T": [
      "CPH241",
      "OnePlus 10T"
    ],
    "OnePlus 10R": [
      "CPH2411",
      "OnePlus 10R"
    ],
    "OnePlus 10 Pro 5G": [
      "OnePlus 10 Pro 5G",
      "NE2210",
      "NE2211",
      "NE2213",
      "NE2215",
      "NE2217"
    ],
    "OnePlus 11 5G": [
      "PHB110",
      "CPH2449",
      "CPH2447",
      "OnePlus 11 5G"
    ],
    "OnePlus Nord N30 5G": [
      "OnePlus Nord N30 5G",
      "CPH2515",
      "CPH2513"
    ],
    "OnePlus Nord (Basic)": [
      "AC200",
      "OnePlus Nord"
    ]
  },
  "Xiaomi": {
    "XIAOMI 12T Pro": [
      "12T Pro",
      "22081212G",
      "22081212UG"
    ],
    "XIAOMI Mi 10T": [
      "Mi 10T",
      "M2007J3SY"
    ],
    "Xiaomi Mi 10T Pro": [
      "Mi 10T Pro",
      "M2007J3SG"
    ]
  },
  "HuaWei": {
    "Huawei Nova 9": [
      "Huawei Nova 9",
      "NAM-LX9",
      "NAM-AL00"
    ],
    "Huawei Nova 9 Pro": [
      "Huawei Nova 9 Pro",
      "RTE-AL00",
      "Hebe-BD00"
    ]
  },
  "Motorola": {
    "Moto G (2025)": [
      "Moto G (2025)",
      "PB5X0002US",
      "XT2513",
      "T2513"
    ],
    "Razr (2025)": [
      "Razr (2025)",
      "XT2553",
      "PB880025US",
      "PB770070US",
      "PB770019US",
      "PB2J0018US"
    ],
    "Razr (2023)": [
      "Razr (2023)",
      "XT2323"
    ],
    "Edge (2025)": [
      "Edge (2025)",
      "XT2519"
    ],
    "Edge (2023)": [
      "Edge (2023)",
      "XT2305"
    ],
    "ThinkPhone": [
      "ThinkPhone",
      "Think Phone",
      "XT2309"
    ]
  },
  "Sharp Aquos": {
    "Sharp Aquos Wish2": [
      "Aquos Wish2",
      "SH-51C"
    ]
  },
  "Sony": {
    "Sony Xperia 1 V": [
      "Sony Xperia 1V",
      "Sony Xperia 1 V",
      "XQDQ62",
      "XQ-DQ72",
      "XQ-DQ54",
      "XQ-DQ44",
      "XQ-DQ54",
      "XQ-DQ62",
      "SO-51D",
      "SOG10",
      "A301SO"
    ]
  }
}